<template>
  <div id="contact" dir="rtl">
    <article>
      <h1 class="main-title">צור קשר</h1>
    </article>

    <article class="container" id="main-content">
      <div class="columns">
        <div class="column is-2" />

        <contactForm class="column is-4" id="contactForm" v-show="true" />

        <div class="container">
          <contactInfo />
          <Map class="column" id="map" />
          <h5 id="name">
            עו"ד ונוטריון איילת נוף
            <b-icon pack="fas" icon="briefcase" size="is-small" type="is-dark" id="briefcase-icon" />
          </h5>
        </div>

        <div class="column is-2" />
      </div>
    </article>

    <article>
      <copyRights id="copyRights" />
    </article>
  </div>
</template>

<script>
import Map from "@/components/Map.vue";
import contactInfo from "@/components/ContactInfo.vue";
import contactForm from "@/components/ContactForm.vue";
import copyRights from "@/components/CopyRights.vue";

export default {
  name: "contact",
  components: {
    Map,
    contactInfo,
    contactForm,
    copyRights
  },
  metaInfo() {
    return {
      title: "איילת נוף צור קשר",
      meta: [
        {
          name: "description",
          content: "ניתן ליצור קשר בטלפון או באימייל וכן באמצעות טופס באתר"
        }
      ]
    };
  }
};
</script>

<style scoped>
#main-content {
  padding-top: 2.55vh;
}
#contactForm {
  padding-top: 0;
}
#map {
  padding-top: 2.2vh;
  padding-bottom: 0;
  padding-right: 0;
}
#name {
  color: #663300;
  font-size: 137%;
  padding-right: 1.6vh;
  margin-top: -7.5vh;
}
#briefcase-icon {
  padding-right: 1.68vh;
}
#copyRights {
  padding-top: 1.85rem;
}
</style>
